module.exports = __webpack_public_path__ + "img/bell.0dd1b336.png";